import { TextStyles } from '@/constants';
import { SectionContainer } from '@/modules/pmt/components/SectionContainer';
import styled from 'styled-components';
import Typography from '../../../../components/Typography';

export const StyledSectionContainer = styled(SectionContainer)(({ theme }) => ({
  gap: theme.spacing[16],
}));

export const HeaderSection = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: 0,
  gap: theme.spacing[4],
}));

export const VerifiedContent = styled(Typography).attrs({
  variant: TextStyles['Heading 6'],
})(({ theme }) => ({
  color: theme.colors.highEmphasisWhite,
}));

export const VerifiedPartnerBadge = styled.div(({ theme }) => ({
  display: 'flex',
  padding: `${theme.spacing[4]} ${theme.spacing[8]}`,
  alignItems: 'center',
  gap: theme.spacing[4],
  height: '24px',
  backgroundColor: theme.colors.blue,
  borderRadius: '100px',
}));

export const SectionTitle = styled.div(({ theme }) => ({
  marginTop: theme.spacing[4],
}));

export const Description = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})(() => ({
  opacity: 0.6,
}));

export const ProductsContainer = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[8],
  width: '100%',
  height: '100%',

  '::-webkit-scrollbar': {
    height: 5,
  },

  '::-webkit-scrollbar-track': {
    background: theme.colors.hoverBlack,
    borderRadius: theme.spacing[2],
  },

  '::-webkit-scrollbar-thumb': {
    background: theme.colors.scrollBarThumb,
    borderRadius: theme.spacing[2],
  },

  [`${theme.mediaBreakpointUp.md}`]: {
    overflowX: 'auto',
    flexDirection: 'row',
    gap: theme.spacing[16],
    paddingBottom: '15px',
  },
}));
